import {Box, Skeleton} from '@mui/material'
import {Colors} from '@sweatpals/react-ui-kit'
import React from 'react'

const OrderLoader = () => (
    <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        maxWidth: '945px',
        flexDirection: 'column',
        padding: '0 20px',
        boxSizing: 'content-box',
        margin: '0 auto'
    }}>
      <Skeleton variant="rectangular" width={175} height={20} sx={{borderRadius: '12px', backgroundColor: Colors.white_a60, mb: '17px'}} />
      <Box sx={{display: 'flex', gap: '8px', mb: '17px'}}>
        <Skeleton variant="rectangular" width={130} height={8} sx={{borderRadius: '12px', backgroundColor: Colors.white_a50}} />
        <Skeleton variant="rectangular" width={348} height={8} sx={{borderRadius: '12px', backgroundColor: Colors.white_a50}} />
      </Box>
      <Skeleton variant="rectangular" width={351} height={501} 
        sx={{
          borderRadius: '24px', 
          backgroundColor: Colors.white_a20,
          border: `1px solid ${Colors.white_a5}`,
          mb: '42px'
        }}
      />
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '27px', width: '100%'}}>
        <Skeleton variant="rectangular" width={155} height={8} sx={{borderRadius: '12px', backgroundColor: Colors.white_a30}} />
        <Skeleton variant="rectangular" width={46} height={8} sx={{borderRadius: '12px', backgroundColor: Colors.white_a30}} />
      </Box>
      <Skeleton variant="rectangular" width='100%' height={175} 
        sx={{
          borderRadius: '8px', 
          backgroundColor: Colors.white_a20,
          border: `1px solid ${Colors.white_a5}`,
          mb: '27px'
        }}
      />
      <Skeleton variant="rectangular" width='100%' height={175} 
        sx={{
          borderRadius: '8px', 
          backgroundColor: Colors.white_a20,
          border: `1px solid ${Colors.white_a5}`,
        }}
      />
    </Box>
  )

export default OrderLoader